import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Hidden,
  LinearProgress,
  SelectChangeEvent,
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik } from 'formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import {
  AddDistributorRequestBody,
  DistributorListType,
  newRmType,
  RmsType,
} from '../../redux-store/types/api-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  addDistributor,
  editDistributor,
  getDistributorById,
  getRMsList,
} from '../../redux-store/actions/userManagement';
import { DistributorSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import { Location } from 'history';
import { CountryCodesDropDown } from '../commonComponents';
import {
  DistributorTypesForUserManageMent,
  mappingRmWithDistributors,
  YesNoMaster,
} from '../../utils/constant';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { nonDigitRegex } from '../../utils/regex';
import { citiesType, mdmsCitiesList } from '../../redux-store/types/mdms';
import { getCitiesList } from '../../redux-store/actions';
import { RootStateType } from '../../redux-store/reducers';
import UseRadioGroup from '../../lib/formik/Radio';
import { checkApplicableForYes } from '../../utils/utilityFunctions';

export const filterRmsListAndAddLocation = (
  rmDropDownMaster: RmsType[],
  value: string
): RmsType[] => {
  return rmDropDownMaster.filter((rms) => rms.location === value);
};

export default function AddDistributor({
  location,
}: {
  location: Location<{ typeOfDistributor: string; distributorId: number }>;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  //const [formikValues, setFormikValues] = useState<AddDistributorRequestBody | null>();
  const { typeOfDistributor, distributorId } = location.state || {};
  const [rmDropDownMaster, setRmDropDownMaster] = useState<RmsType[]>([]);
  const { location: branchLocation } = useSelector((store: RootStateType) => store.auth);
  const initialValues: AddDistributorRequestBody = {
    name: '',
    email: '',
    countryNameAndCode: 'India: +91',
    countryCode: '+91',
    phone: '',
    panNumber: '',
    aprn: '',
    euin: '',
    arnCode: '',
    location: '',
    pincode: '',
    buildingNo: '',
    streetName: '',
    city: '',
    state: '',
    type: typeOfDistributor || '',
    isRia: '',
    country: '',
    isActive: true,
    rmId: null,
    distributorStrategies: [],
  };

  // useEffect(() => {
  //   let isComponentActive = true;
  //   (async function () {
  //     try {
  //       if (!formikValues) return;
  //       if (distributor) {
  //         await dispatch(editDistributor(id, formikValues));
  //       } else {
  //         await dispatch(addDistributor(formikValues));
  //       }

  //       if (!isComponentActive) return;
  //       history.push('distributors', { distributorType: formikValues.type });
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  //   return () => {
  //     isComponentActive = false;
  //   };
  // }, [formikValues]);

  const [mdmsCities, setMdmsCitiesList] = useState<mdmsCitiesList[]>([]);
  const [distributorDetails, setDistributorDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        const res = (await dispatch(getRMsList({ isActive: true }))) as unknown as newRmType;
        const citiesMdmsMasters = (await dispatch(getCitiesList())) as unknown as citiesType;
        let locationForCity = '';
        if (distributorId) {
          const getDistributorDetails = (await dispatch(
            getDistributorById(distributorId)
          )) as unknown as DistributorListType;
          const {
            name,
            panNumber,
            aprn,
            euin,
            arnCode,
            pincode,
            buildingNo,
            streetName,
            city,
            state,
            country,
            id,
            type,
            isRia,
            rmId,
            isActive,
            strategies,
            location,
          } = getDistributorDetails;
          const { countryCode, countryNameAndCode, email, phone } = getDistributorDetails.user || {
            countryCode: '+91',
            countryNameAndCode: 'India: +91',
            email: '',
            phone: '',
          };

          setDistributorDetails({
            ...distributorDetails,
            name,
            panNumber,
            aprn,
            euin,
            arnCode,
            pincode,
            buildingNo,
            streetName,
            city,
            state,
            country,
            email,
            phone,
            id,
            type,
            isRia: Object.keys(YesNoMaster).includes(isRia) ? isRia : 'no',
            rmId,
            isActive,
            countryNameAndCode: countryNameAndCode ? countryNameAndCode : 'India: +91',
            countryCode: countryCode ? countryCode : '+91',
            distributorStrategies: strategies.map((strategy) => {
              return {
                id: strategy?.id as string,
                strategyId: strategy?.id as string,
              };
            }),
            location,
          });
          locationForCity = location || '';
        } else {
          setDistributorDetails({
            ...distributorDetails,
            location: branchLocation || '',
          });
        }
        setMdmsCitiesList(
          citiesMdmsMasters.cities.filter((item) => item.isActive || item.code === locationForCity)
        );
        if (!isComponentAlive) return;
        const { rms } = res || {};
        setRmDropDownMaster(rms);
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isComponentAlive = false;
    };
  }, []);

  const onSubmit = async (values: AddDistributorRequestBody) => {
    const stratagyIds = values.distributorStrategies?.map(
      (strategies) => strategies.strategyId
    ) as string[];

    const submissionValues = {
      ...values,
      aprn: checkApplicableForYes(values.isRia) ? '' : values.aprn,
      euin: checkApplicableForYes(values.isRia) ? '' : values.euin,
      countryCode: values.countryNameAndCode?.split(':')[1].trim(),
      strategyIds: stratagyIds,
    };

    try {
      if (distributorId) {
        await dispatch(editDistributor(distributorId, submissionValues));
        history.push('distributor-details', { distributorType: values.type, distributorId });
      } else {
        await dispatch(addDistributor(submissionValues));
        history.push('distributors', { distributorType: values.type });
      }
    } catch (e) {
      console.error((e as Error).message);
    }
    //setFormikValues({ ...values, countryCode: values.countryNameAndCode?.split(':')[1].trim() });
  };

  return (
    <>
      <Formik
        initialValues={distributorDetails}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validationSchema={DistributorSchema(mdmsCities.map((city) => city.code))}>
        {({ handleSubmit, values, setFieldValue, setValues, resetForm }) => (
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
              py: { xs: 2, sm: 5 },
              pl: { xs: 0, sm: 5 },
              mt: { xs: 2, sm: 5 },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Hidden smUp={true}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    distributorId
                      ? history.push(`distributor-details`, {
                          distributorType: values.type,
                          distributorId,
                        })
                      : history.push('distributors', { distributorType: values.type })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: '#1C2D47',
                  }}>
                  Back
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: 2,
                  py: 2,
                  pl: { xs: 3, sm: 0 },
                  color: 'primary.main',
                  bgcolor: 'rgba(238, 244, 251, 0.5)',
                }}>
                <PersonOutlineOutlinedIcon fontSize="large" />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    pl: 1,
                  }}>
                  User Management
                </Typography>
              </Box>
            </Hidden>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Hidden only="xs">
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    distributorId
                      ? history.push(`distributor-details`, {
                          distributorType: values.type,
                          distributorId,
                        })
                      : history.push('distributors', { distributorType: values.type })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
              </Hidden>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: '#1C2D47',
                  pl: { xs: 3, sm: 0 },
                  textTransform: 'capitalize',
                }}>
                {typeOfDistributor
                  ? 'Onboarding Distributor/RIA Details'
                  : `${values.type} ${
                      checkApplicableForYes(values.isRia) ? 'RIA' : 'Distributor'
                    } Detail`}
              </Typography>
            </Box>
            {loading ? (
              <LinearProgress />
            ) : (
              <>
                {typeOfDistributor && (
                  <>
                    <Grid
                      container
                      display={'flex'}
                      alignItems={'center'}
                      rowSpacing={1}
                      columnSpacing={4}
                      px={4}
                      pt={3}>
                      <Grid item xs={12} sm={6} md={4}>
                        <MFSelectField
                          name="type"
                          items={Object.keys(DistributorTypesForUserManageMent).map((_ele) => ({
                            key: _ele,
                            value: DistributorTypesForUserManageMent[_ele],
                          }))}
                          label="Type *"
                          onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                            setValues({
                              ...values,
                              ...initialValues,
                              location: branchLocation,
                              type: value as unknown as string,
                              isRia: values.isRia || '',
                            });
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <UseRadioGroup
                          formLabel="RIA *"
                          name="isRia"
                          items={Object.keys(YesNoMaster).map((userType) => ({
                            label: YesNoMaster[userType],
                            value: userType,
                          }))}
                          onChange={({
                            target: { value },
                          }: React.ChangeEvent<HTMLInputElement>) => {
                            resetForm();
                            setValues({
                              ...initialValues,
                              type: values.type,
                              isRia: value,
                              aprn: checkApplicableForYes(value) ? '' : initialValues.aprn,
                              euin: checkApplicableForYes(value) ? '' : initialValues.euin,
                            });
                          }}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
                {(Object.keys(YesNoMaster).includes(values.isRia) || values?.id) && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={4} pt={3}>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="name"
                        label={`${
                          checkApplicableForYes(values.isRia) ? 'RIA' : 'Distributor'
                        } Name *`}
                        placeholder={`Enter ${
                          checkApplicableForYes(values.isRia) ? 'RIA' : 'Distributor'
                        } Name`}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField name="email" label="Email Id *" placeholder="Enter Email Id" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="phone"
                        label={`Mobile Number ${values.type === 'individual' ? '*' : ''}`}
                        placeholder="Enter Mobile Number"
                        // startAdornment={
                        //   <CountryCodesDropDown
                        //     name={`countryNameAndCode`}
                        //     value={values.countryNameAndCode}
                        //   />
                        // }
                        regexForFilterValue={nonDigitRegex}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="arnCode"
                        label="ARN Code"
                        placeholder="Enter ARN Code"
                        inputProps={{ style: { textTransform: 'uppercase' } }}
                        onChange={(e) => {
                          setFieldValue('arnCode', e.target.value.toUpperCase());
                        }}
                      />
                    </Grid>
                    {!checkApplicableForYes(values.isRia) && (
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="aprn"
                            label="APRN Number *"
                            placeholder="Enter APRN Number"
                            inputProps={{ style: { textTransform: 'uppercase' } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="euin"
                            label={`EUIN Number${values.type === 'individual' ? ' *' : ''}`}
                            placeholder="Enter EUIN Number"
                            inputProps={{ style: { textTransform: 'uppercase' } }}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} sm={6} md={4}>
                      <SearchableSelect
                        name={`location`}
                        label="Select location *"
                        items={mdmsCities.map((city) => ({
                          key: city.name,
                          value: city.code,
                        }))}
                        onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                          setValues({
                            ...values,
                            location: value as string,
                            rmId: null,
                          });
                        }}
                        disabled={!!distributorId}
                        searchFieldPlaceholder={'Search location'}
                      />
                    </Grid>
                    {values.type === 'individual' && mappingRmWithDistributors && (
                      <Grid item xs={12} sm={6} md={4}>
                        {/* <MFTextField name="rmName" label="RM Name" placeholder="Enter RM Name" /> */}
                        <SearchableSelect
                          name="rmId"
                          label="RM Name *"
                          items={filterRmsListAndAddLocation(rmDropDownMaster, values.location)
                            .sort((rm1, rm2) =>
                              (rm1['name'] || '')
                                .toString()
                                .localeCompare((rm2['name'] || '').toString())
                            )
                            .map((item) => ({
                              key: item.name,
                              value: item.id,
                            }))}
                          searchFieldPlaceholder={'Search RM'}
                          disabled={!values.location}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="panNumber"
                        label="PAN"
                        placeholder="Enter Pan"
                        inputProps={{ style: { textTransform: 'uppercase' } }}
                        onChange={(e) => {
                          setFieldValue('panNumber', e.target.value.toUpperCase());
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField name="pincode" label="Pincode" placeholder="Enter Pincode" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="buildingNo"
                        label="Building Number"
                        placeholder="Enter Building Number"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="streetName"
                        label="Street Name"
                        placeholder="Enter Street Name"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField name="state" label="State" placeholder="Enter State" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField name="city" label="City" placeholder="Enter City" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField name="country" label="Country" placeholder="Enter Country" />
                    </Grid>
                  </Grid>
                )}
                <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 3 }}>
                  <MFSubmitButton label="Save" />
                </Box>
              </>
            )}
          </Box>
        )}
      </Formik>
    </>
  );
}
